import React from 'react';
import edgeBoostLogo from '../assets/images/EDGE_Boost_Logo_v2.png';

/**
 * Branded error fallback component for error boundaries
 * @param {Object} props - Component props
 * @param {Error} props.error - The error that occurred
 * @param {Function} props.resetErrorBoundary - Function to reset the error boundary
 */
const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="error-fallback">
      {/* EDGE BOOST Logo */}
      <div className="error-fallback__logo">
        <img 
          src={edgeBoostLogo} 
          alt="EDGE BOOST" 
        />
      </div>
      
      {/* Error Content */}
      <div className="error-fallback__content">
        <h1 className="error-fallback__title">
          Oops! Something went wrong...
        </h1>
        
        <p className="error-fallback__message">
          We're sorry, but something unexpected happened. Our team has been notified and is working to fix this issue.
        </p>
        
        {/* Error Details (only in development) */}
        {process.env.NODE_ENV === 'development' && error && (
          <details className="error-fallback__error-details">
            <summary>
              Error Details (Development Only)
            </summary>
            <pre>
              {error.message}
              {error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        )}
        
        {/* Action Buttons */}
        <div className="error-fallback__actions">
          <button
            onClick={resetErrorBoundary}
            className="error-fallback__button error-fallback__button--primary"
          >
            Try Again
          </button>
          
          <button
            onClick={() => window.location.href = '/'}
            className="error-fallback__button error-fallback__button--secondary"
          >
            Go Home
          </button>
        </div>
        
        {/* Contact Information */}
        <div className="error-fallback__support">
          <p>
            Need help? Contact our support team:
          </p>
          <a href="mailto:support@edgemarkets.io">
            support@edgemarkets.io
          </a>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
